module.exports = __webpack_public_path__ + "media/images/pic/certificates/about-us/big/brc-6f59715c994ee8a4e6cac09e323e1006.jpg";